import { useState } from 'react';

const faqs = [
  {
    q: '什么是三级片？三级片与色情片有何区别？',
    a: '三级片是指根据香港《电影检查条例》被评定为第III级的电影，即只准年满18岁人士观看。三级片不等于色情片——第III级是基于年龄限制的分类标签，涵盖暴力、恐怖、情欲等多种成人题材。许多三级片在艺术性、社会批判性和文化价值上具有重要地位，与纯粹以感官刺激为目的的色情片存在本质区别。',
  },
  {
    q: '香港电影三级分级制度是何时建立的？',
    a: '香港电影三级分级制度于1988年11月10日正式生效，以《电影检查条例》（第392章）为法律依据。该制度将电影分为第I级（适合任何年龄）、第II级（儿童不宜）和第III级（只准18岁或以上人士观看）。1995年，第II级进一步细分为IIA和IIB两级，形成现行的四级分类体系。',
  },
  {
    q: '三级片在亚洲电影史中具有怎样的文化地位？',
    a: '三级片在亚洲电影史中占有独特的文化位置。1990年代是香港三级片的黄金时代，年产超过百部，占据电影市场相当份额。三级片不仅是商业电影的重要组成部分，也为许多电影人提供了创作起点，同时反映了特定时代的社会价值观和文化变迁。从学术角度看，三级片是研究大众文化、性别政治和审查制度的珍贵样本。',
  },
  {
    q: '香港与其他地区的电影分级制度有何不同？',
    a: '香港三级制与美国MPAA（分为G/PG/PG-13/R/NC-17五级）、英国BBFC（U/PG/12A/12/15/18六级）、日本映伦（G/PG12/R15+/R18+四级）存在显著差异。香港三级制以简洁明了著称，且第III级在市场中被广泛接受，不同于美国NC-17级在院线排片上面临的阻力。各国分级制度的差异，反映了不同的法律传统、文化价值观和社会共识。',
  },
  {
    q: '本站的研究内容是否具有学术权威性？',
    a: '本站由电影研究学者和资深影评人共同编撰，内容基于公开的学术文献、法律文件和电影史料，力求客观、准确、全面。我们坚持学术研究的严谨态度，对每篇文章进行多轮审校，确保信息的可靠性和分析的深度。同时，我们持续关注该领域的学术动态，定期更新内容。',
  },
  {
    q: '中国大陆是否有电影分级制度？',
    a: '中国大陆目前采用电影审查制而非分级制。所有在中国大陆公映的电影都必须通过国家电影局审查，获得《电影公映许可证》。近年来，关于引入电影分级制度的讨论日趋热烈，香港三级制度的成功运作为大陆的改革讨论提供了有价值的参照经验。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-semibold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            关于三级片分级制度的常见疑问解答
          </p>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="border border-background-200/70 rounded-lg overflow-hidden bg-background-50"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <span className="text-sm md:text-base font-medium text-foreground-950 pr-4">
                  {faq.q}
                </span>
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  {openIndex === idx ? (
                    <i className="ri-subtract-line text-lg text-foreground-500"></i>
                  ) : (
                    <i className="ri-add-line text-lg text-foreground-500"></i>
                  )}
                </span>
              </button>
              {openIndex === idx && (
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}